import React from "react";

import { Container } from "react-bootstrap";

import PortfolioClassic from "../components/portfolio/portfolioClassic";
import NextPageContent from "../components/next/NextPageContent";
import Footer from "../components/footer/Footer";
import HeaderNormal from "../components/header/HeaderNormal";
import { Helmet } from "react-helmet";

function WorkTow(props) {
  return (
    <React.Fragment>
      <Helmet>
        <title>Portfolio | Mystirien</title>
        <meta property="og:title" content="Portfolio | Mystirien" />
        <meta
          property="og:description"
          content="Discover Mystirien’s Celtic-fantasy portfolio: music, artwork, and projects that transport you to otherworldly realms."
        />
        <meta property="og:url" content="https://mystirien.com/portfolio" />
        <meta
          property="og:image"
          content="https://mystirien.com/assets/img/mystirien-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <HeaderNormal
        className="background-section text-uppercase"
        description="The Signs of My Passage Across Lands and Roads"
      >
        Marks Upon <br />
        the Road
      </HeaderNormal>
      <Container fluid className="mt-section">
        <PortfolioClassic
          col={3}
          colGap={50}
          colGapTablet={30}
          rowGap={50}
          rowGapTablet={30}
        />
      </Container>

      <NextPageContent className="section-margin" />
      <Footer />
    </React.Fragment>
  );
}

export default WorkTow;
